import type { OnboardingTodo } from "../Todos.constants";
import {
  FIRST_SUPPORTED_ONBOARDING_TODO_YEAR,
  LAST_SUPPORTED_ONBOARDING_TODO_YEAR
} from "../Todos.constants";
import { getOnboardingTodoLabel } from "./getOnboardingTodoLabel";

export function isTodoSpecificOnboardingTodo(
  todoLabel: string,
  onboardingTodo: OnboardingTodo
) {
  for (
    let year = FIRST_SUPPORTED_ONBOARDING_TODO_YEAR;
    year < LAST_SUPPORTED_ONBOARDING_TODO_YEAR + 1;
    year++
  ) {
    if (todoLabel === getOnboardingTodoLabel(onboardingTodo, year)) {
      return true;
    }
  }

  return false;
}
